var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d2679b28513a61836e1558d7bfd4f34f44be8cf9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lp@ab-6d"]={id:"d2679b28513a61836e1558d7bfd4f34f44be8cf9"};
      